"use client";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "..";
import { ContextProps, useGlobalContext } from "@/contexts/AppContext";
import Image from "next/image";
import styles from "./Slider.module.scss";

interface Props {
	slides: any[];
}

const Slider = ({ slides }: Props) => {
	const { theme, drinkType }: ContextProps = useGlobalContext();
	const [currentIndex, setCurrentIndex] = useState(0);
	const [animating, setAnimating] = useState(false);
	const [direction, setDirection] = useState<"next" | "prev" | null>(null);
	const animationDuration = 500;
	const sliderRef = useRef<HTMLDivElement>(null);

	const goToPrevSlide = () => {
		if (animating) return;
		setDirection("prev");
		setAnimating(false);
		setTimeout(() => {
			const newIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
			setCurrentIndex(newIndex);
			setAnimating(false);
			setDirection(null);
		}, animationDuration);
	};
	const goToNextSlide = () => {
		if (animating) return;
		setDirection("prev");
		setAnimating(false);
		setTimeout(() => {
			const newIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
			setCurrentIndex(newIndex);
			setAnimating(false);
			setDirection(null);
		}, animationDuration);
	};

	const getVisibleSlides = () => {
		const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
		const nextIndex = (currentIndex + 1) % slides.length;
		return [
			{ index: prevIndex, position: "slide__prevSlide" },
			{ index: currentIndex, position: "slide__activeSlide" },
			{ index: nextIndex, position: "slide__nextSlide" },
		];
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.deals}>
				<Image alt="" fill src={`/svgs/dealsAndOffers-${theme}.svg`} />
			</div>
			<div className={styles.text}>
				<h1 data-type={theme} className={styles.text_header}>
					DEALS / OFFERS
				</h1>
				<p data-type={theme} className={styles.text_subtext}>
					Lorem ipsum dolor sit amet consectetur. Amet nibh justo vitae congue
					tincidunt massa amet duis.
				</p>
			</div>
			<div className={styles.container} data-type={drinkType}>
				<div
					className={`${styles.slider} ${
						animating ? styles[`animating_${direction}`] : ""
					}`}
				>
					{getVisibleSlides().map(({ index, position }) => (
						<div
							className={`${styles.slide} ${styles[position]} ${
								animating ? styles[`animating_${direction}`] : ""
							}`}
							key={index}
						>
							<span className={styles.slideIndex}>{index}</span>
						</div>
					))}
				</div>
				<div className={styles.grid}>
					<div className={styles.end}>
						<div className={styles.slider_button_container}>
							<div
								onClick={goToPrevSlide}
								data-type={theme}
								className={styles.slider_button}
							>
								<div className={styles.icon}>
									<Image
										src={`/svgs/chevron-${theme}.svg`}
										fill
										alt=""
									/>
								</div>
							</div>
							<div
								data-type={theme}
								onClick={goToNextSlide}
								className={styles.slider_button}
							>
								<div className={styles.icon}>
									<Image
										src={`/svgs/chevron-${theme}.svg`}
										fill
										alt=""
									/>
								</div>
							</div>
						</div>
						<Button className={styles.button}>View All</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Slider;
